import React from "react";
import PlanSummary from "./PlanSummary";
import CheckoutButton from "./CheckoutButton";
import CheckoutError from "./CheckoutError";

interface CheckoutCardProps {
  planType: "MONTHLY" | "YEARLY" | "SEMIANNUAL" | null;
  isLoading: boolean;
  error: string | null;
  errorDetails: string | null;
  debugInfo?: Record<string, any> | null;
  onCheckout: () => void;
  onRetry: () => void;
}

const CheckoutCard: React.FC<CheckoutCardProps> = ({
  planType,
  isLoading,
  error,
  errorDetails,
  debugInfo,
  onCheckout,
  onRetry,
}) => {
  return (
    <div className="bg-white rounded-2xl p-8 shadow-soft text-center">
      <h1 className="text-2xl font-bold mb-6">Complete Your Subscription</h1>

      {planType && <PlanSummary planType={planType} />}

      {error ? (
        <CheckoutError
          errorMessage={error}
          errorDetails={errorDetails}
          debugInfo={debugInfo}
          onRetry={onRetry}
          isRetrying={isLoading}
        />
      ) : (
        <>
          <CheckoutButton onClick={onCheckout} isLoading={isLoading} />

          <p className="mt-4 text-sm text-gray-500">
            You'll be redirected to Stripe's secure payment page to complete
            your subscription.
          </p>
        </>
      )}
    </div>
  );
};

export default CheckoutCard;
